<template>
	<AppModal
		v-bind="$attrs"
		:isFullscreen="false"
		:close="close"
		@close="$emit('close')"
	>
		<!-- Header slot, solo si está -->
		<template #header v-if="$slots.header">
			<slot name="header" />
		</template>
		<!-- Default (body) slot -->
		<slot />
		<!-- Footer-top slot, solo si está -->
		<template #footer-top v-if="$slots['footer-top']">
			<slot name="footer-top" />
		</template>
		<!-- Footer slot, solo si está -->
		<template #footer v-if="$slots.footer">
			<slot name="footer" />
		</template>
	</AppModal>
</template>

<script>
import AppModal from './AppModal.vue'

export default {
	name: 'AppModalCentered',
	components: { AppModal },
	emits: ['close'],
	inheritAttrs: false, // Así controlas las props con $attrs
	props: {
		title: { type: String, default: '' },
		close: { type: Boolean, default: false }
	}
}
</script>
